module.exports = __webpack_public_path__ + "img/block-tourist.8e16db06.png";